<template>
  <div>
    <header v-if="!(isWC() && !isMobile())" :style="style">
      <overlay :isActive="showOverlay" @closed="showOverlay = false"></overlay>
      <top-menu @open-overlay="showOverlay = true" />
    </header>
    <div v-if="!isWC()" :class="headAbsolute != '' ?'head headersize':'head headersize-noimage'" :style="{ 'background-image': headAbsolute }" />
    <section class="container">
      <slot />
    </section>
    <page-footer />
  </div>
</template>
<script>
import TopMenu from "./../shared/TopMenu.vue";
import PageFooter from "./../shared/footer.vue";
import overlay from "./overlay.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    TopMenu,
    PageFooter,
    overlay
  },
  data() {
    return {
      style: {
        "min-height": this.isWC() ? "80px" : "0"
      },
      showOverlay: false
    };
  },
  computed: {
    ...mapGetters(["hqDoc"]),
    headAbsolute() {
      if (this.hqDoc) {
        return `url(${this.hqDoc.ProfileImage})`;
      }
      return "";
    }
  }
};
</script>
